export default __webpack_public_path__ + "static/media/microsite_badge.faa75a58.png";